import { cloneDeep } from "lodash";

const SET_EVENTS_FETCHED = "app/rum/SET_EVENTS_FETCHED";
const SET_MARKET_EVENTS_FETCHED = "app/rum/SET_MARKET_EVENTS_FETCHED";
const SET_IS_FILTERS_PANEL_VISIBLE = "app/rum/SET_IS_FILTERS_PANEL_VISIBLE";
const SET_CHART_FILTERS = "app/rum/SET_CHART_FILTERS";
const SET_LOADING_CHARTS = "app/rum/SET_LOADING_CHARTS";
const SET_LOADED_CHART = "app/rum/SET_LOADED_CHART";
const SET_REFRESH = "app/rum/SET_REFRESH";
const SET_MARKET_REFRESH = "app/rum/SET_MARKET_REFRESH";
const SET_ERROR_CHARTS = "app/rum/SET_ERROR_CHARTS";
const RESET_ERROR_CHARTS = "app/rum/RESET_ERROR_CHARTS";

// Events
// ______________________________________________________________________
const SET_PAGE_LOADS_EVENTS = "app/rum/SET_PAGE_LOADS_EVENTS";
const SET_CONNECTION_TIME_EVENTS = "app/rum/SET_CONNECTION_TIME_EVENTS";
const SET_DEVICE_USAGE_EVENTS = "app/rum/SET_DEVICE_USAGE_EVENTS";
const SET_DIAGNOSTICS_EVENTS = "app/rum/SET_DIAGNOSTICS_EVENTS";
const SET_DIAGNOSTICS_ERRORS_READING_PERFOMANCE_EVENTS = "app/rum/SET_DIAGNOSTICS_ERRORS_READING_PERFOMANCE_EVENTS";
const SET_SETTING_EVENTS = "app/rum/SET_SETTING_EVENTS"
const SET_FWU_EVENTS = "app/rum/SET_FWU_EVENTS";
const SET_FWU_RECONNECTION_TIME_EVENTS = "app/rum/SET_FWU_RECONNECTION_TIME_EVENTS";
const SET_BATTERY_HEALTH_EVENTS = "app/rum/SET_BATTERY_HEALTH_EVENTS";

// Statistics by market
const SET_CONNECTIONS_BY_MARKET = "app/rum/SET_CONNECTIONS_BY_MARKET";
const SET_DIAGNOSTICS_BY_MARKET = "app/rum/SET_DIAGNOSTICS_BY_MARKET";
const SET_FWU_BY_MARKET = "app/rum/SET_FWU_BY_MARKET";

const RESET_EVENTS = "app/rum/RESET_EVENTS";
const RESET_MARKET_EVENTS = "app/rum/RESET_MARKET_EVENTS";

const SET_CONNECTIONS_BY_BROWSER = "app/rum/SET_CONNECTIONS_BY_BROWSER";
const SET_CONNECTIONS_BY_OS = "app/rum/SET_CONNECTIONS_BY_OS";

const initialState = {
  eventsFetched: false,
  marketEventsFetched: false,
  isFiltersPanelVisible: false,
  chartFilters: [],
  loadingCharts: [],
  refresh: false,
  marketRefresh: false,
  errorCharts: [],

  // Events
  // ______________________________________________________________________
  pageLoads: {
    loads: null,
    total: 0,
    avgSpeed: 0
  },
  connectionTime: null,
  deviceUsage: null,
  diagnostics: {
    data: null,
    statistics: null,
    performance: null,
    total: 0
  },
  diagnosticsErrorsReadingPerfomance:{
    data: null,
    statistics: null,
    performance: null,
    total: 0
  },
  settings: {
    data: null,
    performance: null,
    statistics: null,
    selectedSetting: null,
    availableSettings: null,
  },
  fwu: {
    data: null,
    statistics: null,
    performance: null,
    errors: null,
    total: 0
  },
  reconnectionTimeDuringFWU: null,
  batteryHealth: {
    data: null,
    statistics: null,
    performance: null
  },

  // Statistics by market
  connectionsByMarket: {
    statistics: null,
    total: 0
  },
  connectionsByOS: {
    statistics: null,
    total: 0
  },
  connectionsByBrowser: {
    statistics: null,
    total: 0
  },
  diagnosticsByMarket: {
    data: null,
    statistics: null
  },
  fwuByMarket: {
    data: null,
    statistics: null
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_EVENTS_FETCHED: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, eventsFetched: action.payload };
    }

    case SET_MARKET_EVENTS_FETCHED: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, marketEventsFetched: action.payload };
    }

    case SET_IS_FILTERS_PANEL_VISIBLE: {
      const clonedState = cloneDeep(state);

      return { ...clonedState, isFiltersPanelVisible: action.payload };
    }

    case SET_CHART_FILTERS: {
      const clonedState = cloneDeep(state);

      let newChartFilters = [...clonedState.chartFilters];
      const chartId = action.payload.chart;
      const filter = action.payload.filter;

      const idx = clonedState.chartFilters.findIndex((chart) => chart.id === chartId);
      const newConfig = { id: chartId, filter: filter };

      if (idx !== -1) {
        newChartFilters = [
          ...clonedState.chartFilters.slice(0, idx),
          newConfig,
          ...clonedState.chartFilters.slice(idx + 1)
        ];
      } else {
        newChartFilters = [...clonedState.chartFilters, newConfig];
      }

      return { ...clonedState, chartFilters: newChartFilters };
    }

    case SET_LOADING_CHARTS: {
      const clonedState = cloneDeep(state);

      const newloadingCharts = clonedState?.loadingCharts
        ? [...clonedState.loadingCharts, ...action.payload]
        : [...action.payload];

      return {
        ...clonedState,
        loadingCharts: newloadingCharts
      };
    }

    case SET_LOADED_CHART: {
      const clonedState = cloneDeep(state);

      const newloadingCharts = clonedState?.loadingCharts
        ? clonedState.loadingCharts.filter((chartName) => chartName !== action.payload)
        : [];

      return {
        ...clonedState,
        loadingCharts: newloadingCharts
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_MARKET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        marketRefresh: action.payload
      };
    }

    case SET_ERROR_CHARTS: {
      const clonedState = cloneDeep(state);

      const newErrorCharts = clonedState?.errorCharts
        ? [...clonedState.errorCharts, ...action.payload]
        : [...action.payload];

      return {
        ...clonedState,
        errorCharts: newErrorCharts
      };
    }

    case RESET_ERROR_CHARTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        errorCharts: []
      };
    }

    // Events
    // ______________________________________________________________________
    case SET_PAGE_LOADS_EVENTS: {
      const clonedState = cloneDeep(state);

      const newPageLoads = {
        loads: action.payload.loads,
        total: action.payload.total,
        avgSpeed: action.payload.avgSpeed
      };

      return {
        ...clonedState,
        pageLoads: newPageLoads
      };
    }

    case SET_CONNECTION_TIME_EVENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        connectionTime: action.payload
      };
    }

    case SET_DEVICE_USAGE_EVENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deviceUsage: action.payload
      };
    }

    case SET_DIAGNOSTICS_EVENTS: {
      const clonedState = cloneDeep(state);

      const newDiagnostics = {
        ...clonedState.diagnostics,
        ...action.payload
      };

      return {
        ...clonedState,
        diagnostics: newDiagnostics
      };
    }

    case SET_DIAGNOSTICS_ERRORS_READING_PERFOMANCE_EVENTS: {
      const clonedState = cloneDeep(state);

      const newDiagnostics = {
        ...clonedState.diagnosticsErrorsReadingPerfomance,
        ...action.payload
      };

      return {
        ...clonedState,
        diagnosticsErrorsReadingPerfomance: newDiagnostics
      };
    }

    case SET_SETTING_EVENTS: {
      const clonedState = cloneDeep(state);

      const newDiagnostics = {
        ...clonedState.settings,
        ...action.payload
      };

      return {
        ...clonedState,
        settings: newDiagnostics
      };
    }
    
    case SET_FWU_EVENTS: {
      const clonedState = cloneDeep(state);

      const newFwu = {
        ...clonedState.fwu,
        ...action.payload
      };

      return {
        ...clonedState,
        fwu: newFwu
      };
    }

    case SET_FWU_RECONNECTION_TIME_EVENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        reconnectionTimeDuringFWU: action.payload
      };
    }

    case SET_BATTERY_HEALTH_EVENTS: {
      const clonedState = cloneDeep(state);

      const newBatteryHealth = {
        ...clonedState.batteryHealth,
        ...action.payload
      };

      return {
        ...clonedState,
        batteryHealth: newBatteryHealth
      };
    }

    // Statistics by market
    case SET_CONNECTIONS_BY_MARKET: {
      const clonedState = cloneDeep(state);

      const newConnectionsByMarket = {
        statistics: action.payload.statistics,
        total: action.payload.total
      };

      return {
        ...clonedState,
        connectionsByMarket: newConnectionsByMarket
      };
    }

    case SET_DIAGNOSTICS_BY_MARKET: {
      const clonedState = cloneDeep(state);

      const newDiagnosticsByMarket = {
        ...clonedState.diagnosticsByMarket,
        ...action.payload
      };

      return {
        ...clonedState,
        diagnosticsByMarket: newDiagnosticsByMarket
      };
    }

    case SET_FWU_BY_MARKET: {
      const clonedState = cloneDeep(state);

      const newFwuByMarket = {
        ...clonedState.fwuByMarket,
        ...action.payload
      };

      return {
        ...clonedState,
        fwuByMarket: newFwuByMarket
      };
    }

    case RESET_EVENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        pageLoads: {
          loads: null,
          total: 0,
          avgSpeed: 0
        },
        connectionTime: null,
        diagnostics: {
          data: null,
          statistics: null,
          performance: null,
          total: 0
        },
        settings: {
          data: null,
          performance: null,
          statistics: null,
          selectedSetting: null,
          availableSettings: null,
        },
        fwu: {
          data: null,
          statistics: null,
          performance: null,
          errors: null,
          total: 0
        },
        reconnectionTimeDuringFWU: null
      };
    }

    case RESET_MARKET_EVENTS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        connectionsByMarket: null,
        diagnosticsByMarket: null,
        fwuByMarket: null
      };
    }

    default: {
      return state;
    }

    case SET_CONNECTIONS_BY_OS: {
      const clonedState = cloneDeep(state);

      const newConnectionsByOS = {
        statistics: action.payload.statistics,
        total: action.payload.total
      };

      return {
        ...clonedState,
        connectionsByOS: newConnectionsByOS
      };
    }

    case SET_CONNECTIONS_BY_BROWSER: {
      const clonedState = cloneDeep(state);

      const newConnectionsByBrowser = {
        statistics: action.payload.statistics,
        total: action.payload.total
      };

      return {
        ...clonedState,
        connectionsByBrowser: newConnectionsByBrowser
      };
    }
  }
}

export const setEventsFetched = (isFetched) => ({ type: SET_EVENTS_FETCHED, payload: isFetched });

export const setMarketEventsFetched = (isFetched) => ({
  type: SET_MARKET_EVENTS_FETCHED,
  payload: isFetched
});

export const setIsFiltersPanelVisible = (isVisible) => ({
  type: SET_IS_FILTERS_PANEL_VISIBLE,
  payload: isVisible
});

export const setChartFilters = (chart, filter) => ({
  type: SET_CHART_FILTERS,
  payload: { chart, filter }
});

export const setLoadingCharts = (chartIds) => ({ type: SET_LOADING_CHARTS, payload: chartIds });

export const setLoadedChart = (chartId) => ({ type: SET_LOADED_CHART, payload: chartId });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setMarketRefresh = (refresh) => ({ type: SET_MARKET_REFRESH, payload: refresh });

export const setErrorCharts = (chartIds) => ({ type: SET_ERROR_CHARTS, payload: chartIds });

export const resetErrorCharts = () => ({ type: RESET_ERROR_CHARTS });

// Events
// ______________________________________________________________________
export const setPageLoadsEvents = ({ loads, total, avgSpeed }) => ({
  type: SET_PAGE_LOADS_EVENTS,
  payload: { loads, total, avgSpeed }
});

export const setConnectionTimeEvents = (events) => ({
  type: SET_CONNECTION_TIME_EVENTS,
  payload: events
});

export const setDeviceUsageEvents = (events) => ({
  type: SET_DEVICE_USAGE_EVENTS,
  payload: events
});

export const setDiagnosticsEvents = (events) => ({
  type: SET_DIAGNOSTICS_EVENTS,
  payload: events
});

export const setDiagnosticsErrorsReadingPerfomanceEvents = (events) => ({
  type: SET_DIAGNOSTICS_ERRORS_READING_PERFOMANCE_EVENTS,
  payload: events
});

export const setSettingEvents = (events) => ({
  type: SET_SETTING_EVENTS,
  payload: events
});

export const setFwuEvents = (events) => ({
  type: SET_FWU_EVENTS,
  payload: events
});

export const setReconnectionTimeEvents = (events) => ({
  type: SET_FWU_RECONNECTION_TIME_EVENTS,
  payload: events
});

export const setBatteryHealthEvents = (events) => ({
  type: SET_BATTERY_HEALTH_EVENTS,
  payload: events
});

// Statistics by market
export const setConnectionsByMarket = ({ statistics, total }) => ({
  type: SET_CONNECTIONS_BY_MARKET,
  payload: { statistics, total }
});

export const setDiagnosticsByMarket = (events) => ({
  type: SET_DIAGNOSTICS_BY_MARKET,
  payload: events
});

export const setFwuByMarket = (events) => ({
  type: SET_FWU_BY_MARKET,
  payload: events
});

export const resetEvents = () => ({
  type: RESET_EVENTS
});

export const resetMarketEvents = () => ({
  type: RESET_MARKET_EVENTS
});

export const setConnectionsByOS = ({ statistics, total }) => ({
  type: SET_CONNECTIONS_BY_OS,
  payload: { statistics, total }
});

export const setConnectionsByBrowser = ({ statistics, total }) => ({
  type: SET_CONNECTIONS_BY_BROWSER,
  payload: { statistics, total }
});